import React, { useState } from 'react'
import { BsChevronLeft } from 'react-icons/bs'
import SideNav from '../../Components/SideNav'
import styles from "./Styles/Requirements.module.css"
import common from "./Styles/Common.module.css"
import Button from "../../Components/Button"
import { AiFillLike } from 'react-icons/ai'
import { FiEdit, FiUsers } from 'react-icons/fi'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { HiOutlineMinus, HiOutlinePlus } from 'react-icons/hi'
import spaceConfigImage from "../../Assets/spaceConfigImage.png"
import { useNavigate } from 'react-router-dom'

export default function Requirements() {
    const navigate = useNavigate()

  const [quizOutput, setQuizOutput] = useState(['Modern & Elegant','Embracing Rawness','The Outside In'])
  const [spaceConfig, setSpaceConfig] = useState([{
    name:'Cabins',
    quantity:3
  },
  {
    name:'Open Workspace',
    quantity:5
  },
  {
    name:'Meeting Room',
    quantity:2
  },
  {
    name:'Public Space',
    quantity:1
  },
  {
    name:'Circulation & Support Spaces',
    quantity:6
  }])
  const [layout, setLayout] = useState([])


  const SpaceConfiguration = () => {

    const Card = () => {
        return <div className={styles.spaceConfigCard}>
            <div className={styles.spaceConfigCardImage}>
                <img src={spaceConfigImage} />
            </div>

            <div className={styles.spaceConfigCardContent}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
                    <h2>MD CABIN</h2>
                    <div style={{display:'flex',alignItems:'center',gap:8}}>
                        <FiUsers size={20} color="#C2CFE0" />
                        <h2>04</h2>
                    </div>
                </div>
                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                    <h3>Size</h3>
                    <h4>L-23 x W-23 x H-24 </h4>
                </div>
                <div className={styles.sqFtBtn}>
                    125 Sq ft
                </div>
                <div className={styles.addSubtractBtns}>
                    <button><HiOutlineMinus color="#fff" size={22} /></button>
                        <p>03</p>
                    <button><HiOutlinePlus color="#fff" size={22} /></button>
                </div>
            </div>
        </div>
    }

    return <div className={styles.spaceConfig}>
    <h1>SPACE CONFIGURATION</h1>    
    <div className={styles.spaceConfigHeader}>
        <h2>Total Area</h2>
        <h3>13370 <span>Sq ft</span></h3>
    </div>

    <header>
        <div className={styles.legend}>
            <div>
            <div>
                <span style={{backgroundColor:'#FF4906'}}></span>
                <p>Open Workspaces</p>
            </div>
            <p>x24</p>
            </div>
            <div>
            <div>
                <span style={{backgroundColor:'#707ED1'}}></span>
                <p>Cabins</p>
            </div>
            <p>x02</p>
            </div>
            <div>
            <div>
                <span style={{backgroundColor:'#FFB55F'}}></span>
                <p>Meeting Rooms</p>
            </div>
            <p>x03</p>
            </div>
            <div>
            <div>
                <span style={{backgroundColor:'#9C6DFF'}}></span>
                <p>Public Space</p>
            </div>
            <p>x11</p>
            </div>
            <div>
            <div>
                <span style={{backgroundColor:'#FF796C'}}></span>
                <p>Circulation & Support Spaces</p>
            </div>
            <p>x11</p>
            </div>
        </div>
            <div className={styles.separator}></div>
        <div className={styles.totalSeats}>
            <h2>Total Seats</h2>
            <div>
                <FiUsers color="#161C45" size={60} />
                <h3>215</h3>
            </div>
        </div>
            <div className={styles.separator}></div>
        <div>
            pie chart
        </div>
    </header>

    <div className={styles.spaceConfigItems}>

        {spaceConfig.map(i => {
            return <div className={styles.spaceConfigItem}>
            <div className={styles.spaceConfigItemHeader}>
                <div style={{display:'flex',alignItems:'center',gap:16}}>
                    <h2>{i.name}</h2>
                    <h3>x02</h3>
                    <div style={{width:40,height:40}}>
                    <CircularProgressbar value={10} text={`${10}%`}
                        styles={buildStyles({
                        textSize: '28px',
                        pathTransitionDuration: 0.5,
                        textColor: '#41CD70',
                        pathColor:'#41CD70'
                    })}
                     />
                    </div>
                </div>

                <div className={styles.editDelete}>
                    <FiEdit color="#6DB4C4" size={26} />
                    <RiDeleteBin6Line color="#F7685B" size={26} />
                </div>
            </div>

            <div className={styles.spaceConfigCardsContainer}>
                {Array(i.quantity).fill('').map(c => {
                    return <Card />
                })}
            </div>
        </div>
        })}
    </div>
    </div>
  }

  const Layout = () => {
    return <div>
        <h1>LAYOUT</h1>
    </div>
  }

  return (
    <div className={common.container}>
        <div className={common.backIcon}>
            <div onClick={()=>navigate('/dashboard/leads')}>
                <BsChevronLeft size={26} color="#0E1123" />
            </div>
            <p>Back</p>
        </div>

        <main>
            <SideNav />

             <div className={`${common.main} ${styles.main}`}>

                {/* quiz output */}
                <div className={styles.item}>
                    {quizOutput.length == 0 ? <div className={styles.emptyState}>
                        <div>
                        <h1>QUIZ OUTPUT</h1>
                        <h3>Seems like you have not taken the quiz yet.</h3>
                        </div>
                        <Button width={157} bgColor="#299EFE" title="Play Now" />
                    </div> : 
                    <div>
                        <h1>QUIZ OUTPUT</h1>
                        <div className={styles.quizContainer}>
                            {quizOutput.map((item,index) => {
                                return <div className={styles.quiz}>
                                <div className={styles.quizImage}>
                                    <img src="http://cdn.home-designing.com/wp-content/uploads/2022/02/modern-wooden-dining-chairs-with-arms-barrel-backrest-design-tapered-legs-mid-century-modern-danish-furniture-for-dining-room-seating-for-sale-online-light-oak-finish.jpg" />
                                    <div className={index == 0 ? styles.greenQuizLikeBtn : index == 1 ? styles.orangeQuizLikeBtn : styles.greyQuizLikeBtn}>
                                        <div>
                                            <AiFillLike color={index == 0 ? '#0AD071' : index == 1 ? "#DF8823" : '#757575'} size={20} />
                                        </div>
                                        <p>32<span>%</span></p>
                                    </div>
                                </div>
                                <div className={styles.quizContent}>
                                    <h2>{item}</h2>
                                    <ul>
                                        <li><span>Overall look & feel:</span> Clean and uncomplicated spaces</li>
                                        <li><span>Color palette:</span> Whites, Grays and Earthy tones</li>
                                        <li><span>Materials:</span> Wood and Concrete</li>
                                    </ul>
                                </div>
                            </div>
                            })}
                        </div>
                    </div>
                    }
                </div>  

                <div className={styles.item}>
                    {spaceConfig.length == 0 ? <div className={styles.emptyState}>
                        <div>
                        <h1>SPACE CONFIGURATION</h1>
                        <h3>Seems like you have not configured your space yet.</h3>
                        </div>
                        <Button width={157} bgColor="#299EFE" title="Configure Now" />
                    </div> : <SpaceConfiguration /> }
                </div>  

                <div className={styles.item}>
                    {layout.length == 0 ? <div className={styles.emptyState}>
                        <div>
                        <h1>LAYOUT</h1>
                        <h3>Seems like you have not uploaded your layout yet.</h3>
                        </div>
                        <Button width={157} bgColor="#299EFE" title="Upload Now" />
                    </div> : <Layout />}
                </div>    
            </div>
        </main>
    </div>
  )
}
